export const getFormData = (formElements: any) => {
  return Object.assign({},...Array.from(formElements, (item:any) => ({ [item.name]: item.value })))
}
